// removed by extract-text-webpack-plugin
module.exports = {"skeleton":"styles__skeleton___1Bncd","skeleton-loading":"styles__skeleton-loading___1hwNS","whiteBackgroundSkeleton":"styles__whiteBackgroundSkeleton___984Vd","skeleton-loader-gradient":"styles__skeleton-loader-gradient___9K7hs","commons":"styles__commons___2wi_J","skeletonText":"styles__skeletonText___3fJSR","cardContainerClasses":"styles__cardContainerClasses___2TAH3","headerSectionSkeleton":"styles__headerSectionSkeleton___2WE9N","skeletonSubTitle":"styles__skeletonSubTitle___hdjVd","containerSelect":"styles__containerSelect___1Sb3Y","button":"styles__button___LV4Vx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Skeleton/FixedVoiceSkeleton/styles.css
// module id = 2516
// module chunks = 0